import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function BBLCombine() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px]" data-id="element-192">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-8" data-id="element-193">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-194">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-195">
            BEST TREATMENTS TO COMBINE WITH BBL FOREVER YOUNG
          </h2>

          <div className="w-[40px] h-[2px] bg-white mb-10" data-id="element-196"></div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 w-full mb-10" data-id="element-197">
            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-198">
              <h3 className="text-black text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-199">
                Clear + Brilliant
              </h3>
              <p className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-200">
                Looking to smooth out fine lines, refine skin texture, diminish
                acne scars and shrink large pores—all with one powerful
                treatment? At Be CLINICAL, we recommend supplementing your BBL
                with the Clear + Brilliant Touch laser facial. This gentle yet
                effective treatment is your ticket to a fresher, brighter, and
                more dazzling complexion.
              </p>
            </div>

            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-201">
              <h3 className="text-black text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-202">
                HALO Laser
              </h3>
              <p className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-203">
                If you have some time to hide away, you can supplement your BBL
                with HALO Laser, one of our client's most beloved treatments for
                skin transformation. HALO Laser combines both ablative and
                non-ablative lasers during this treatment that allows us to
                resurface up to 30% of the skin, producing more dramatic
                results.
              </p>
            </div>

            <div className="bg-white p-9 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-204">
              <h3 className="text-black text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-205">
                SkinTyte
              </h3>
              <p className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-206">
                Looking for a lift? SkinTyte utilizes intense pulsed light
                technology (IPL) that deeply heats the deep layers of the skin,
                while cooling the surface layer. IPL stimulates the body's
                natural healing process to create new collagen for tighter,
                plumper and more youthful looking skin.
              </p>
            </div>
          </div>

          <p className="font-serif italic text-white text-2xl lg:text-[28px]" data-id="element-207">
            Treat yourself!
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}